module.exports = __webpack_public_path__ + "img/nanyida_lineup.627f1fd2.png";